import flyprivateTestingFilms from './flyprivate_testing_films'
import flyprivateTestingTiers from './flyprivate_testing_tiers'

export default (store) => {
  return {
    flyprivate_testing_films: flyprivateTestingFilms(store),
    flyprivate_testing_tiers: flyprivateTestingTiers(store)
  }
}
